import _taggedTemplateLiteral from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { SpinnerIcon } from "@edenlabllc/ehealth-icons";
var Spinner = styled(SpinnerIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 10px auto;\n"])));
export default Spinner;